var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"logo",staticClass:"ViewmedicaBrochureLogo",class:{ textlogo: !_vm.image, imagelogo: _vm.image },style:({ color: _vm.color }),on:{"dragstart":function($event){$event.stopPropagation();$event.preventDefault();}}})}
var staticRenderFns = []

export { render, staticRenderFns }